// Small pure helpers shared by the Login / OTP screens.

// Convert Persian (۰-۹) and Arabic (٠-٩) digits to Latin (0-9) so users can
// type with a Farsi keyboard while validation + API always see Latin digits.
export function toEnglishDigits(input) {
  if (input == null) return "";
  return String(input)
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
}

export function isValidIranianPhone(phone) {
  return /^09\d{9}$/.test(phone);
}

export function maskPhone(phone) {
  // 09123456789 -> ‎0912 ••• 6789‎ (keeps the number recognizable).
  if (!phone || phone.length !== 11) return phone;
  return `${phone.slice(0, 4)} ••• ${phone.slice(7)}`;
}

export function dashboardPathFor(user) {
  return user?.role === "mechanic" || user?.mechanic ? "/ServiceDashbord" : "/";
}

export default toEnglishDigits;
